// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fms-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background: #1a1d4f;
  color: #fff;
  font-size: 12px;
  z-index: 9;
}
.fms-footer table {
  width: 100%;
  border-collapse: collapse;
}
.fms-footer .dateTimeSection {
  width: 100px;
}
.fms-footer .activityCounterSection {
  width: 130px;
}
.fms-footer .activityCounterSection a {
  margin: 0 4px;
}
.fms-footer .toggleConsole,
.fms-footer .toggleMiniMaps,
.fms-footer .toggleSidebar {
  width: 30px;
}
.fms-footer td {
  padding: 5px;
  border-left: 1px solid rgb(229.5, 229.5, 229.5);
  text-align: center;
  vertical-align: top;
}
.fms-footer a {
  color: #fff;
  line-height: 1;
}
.fms-footer a.active, .fms-footer a:hover {
  opacity: 1;
}
.fms-footer svg {
  min-width: 17px;
  min-height: 17px;
}

@media (max-width: 959px) {
  .fms-footer .activityCounterSection {
    width: auto;
  }
}
@media (max-width: 499px) {
  .toggleConsole,
  .toggleMiniMaps,
  .toggleSidebar {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/Layout/Footer/index.scss","webpack://./src/assets/variables.scss"],"names":[],"mappings":"AAEA;EACC,eAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,mBCLY;EDMZ,WAAA;EACA,eC8Dc;ED7Dd,UAAA;AADD;AAEC;EACC,WAAA;EACA,yBAAA;AAAF;AAEC;EACC,YAAA;AAAF;AAEC;EACC,YAAA;AAAF;AACE;EACC,aAAA;AACH;AAEC;;;EAGC,WAAA;AAAF;AAEC;EACC,YAAA;EACA,+CAAA;EACA,kBAAA;EACA,mBAAA;AAAF;AAEC;EACC,WAAA;EAEA,cAAA;AADF;AAEE;EAEC,UAAA;AADH;AAIC;EACC,eC2BiB;ED1BjB,gBC0BiB;AD5BnB;;AAQA;EAEE;IACC,WAAA;EAND;AACF;AASA;EACC;;;IAGC,aAAA;EAPA;AACF","sourcesContent":["@import './../../assets/variables';\n\n.fms-footer {\n\tposition: fixed;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tbackground: $footerBackground;\n\tcolor: #fff;\n\tfont-size: $baseFontSize;\n\tz-index: 9;\n\ttable {\n\t\twidth: 100%;\n\t\tborder-collapse: collapse;\n\t}\n\t.dateTimeSection {\n\t\twidth: 100px;\n\t}\n\t.activityCounterSection {\n\t\twidth: 130px;\n\t\ta {\n\t\t\tmargin: 0 4px;\n\t\t}\t\n\t}\n\t.toggleConsole,\n\t.toggleMiniMaps,\n\t.toggleSidebar {\n\t\twidth: 30px;\n\t}\n\ttd {\n\t\tpadding: 5px;\n\t\tborder-left: 1px solid $borderColor;\n\t\ttext-align: center;\n\t\tvertical-align: top;\n\t}\n\ta {\n\t\tcolor: #fff;\n\t\t//opacity: 0.6;\n\t\tline-height: 1;\n\t\t&.active,\n\t\t&:hover {\n\t\t\topacity: 1\n\t\t}\n\t}\n\tsvg {\n\t\tmin-width: $baseIconFontSize;\n\t\tmin-height: $baseIconFontSize;\n\t}\n}\n\n// responsive \n\n@media (max-width: 959px) {\n\t.fms-footer {\n\t\t.activityCounterSection {\n\t\t\twidth: auto;\n\t\t}\n\t}\n}\n@media (max-width: 499px) {\n\t.toggleConsole,\n\t.toggleMiniMaps,\n\t.toggleSidebar {\n\t\tdisplay: none;\n\t}\n}","@import 'functions';\n@import 'mixins';\n$themeColor: #1a1d4f;\n$input-focus-box-shadow: none;\n$input-btn-focus-box-shadow: none;\n$btn-active-box-shadow: none;\n$input-focus-border-color: inherit;\n$btn-active-box-shadow: none;\n$input-bg: #fbfeff;\n$input-border-radius: 100px;\n$input-border-radius-sm: 100px;\n$input-border-radius-lg: 100px;\n$input-border-color: #e2e9ef;\n//$input-padding-x-sm: 10px;\n@import 'bs_variables';\n\n// Layouts\n$sidebarWidth: 285px;\n$headerHeight: 46px;\n$footerHeight: 27px;\n$mapFiltersHeight: 36px;\n$mapWidgetsHeight: 150px;\n\n$themeColorInverse: #fff;\n$textColor: #333;\n$body-color: #333;\n$logoColor: $themeColor; //#012D55;\n\n// Header\n\n$borderColor: darken(white, 10%);\n$linkColor: #666;\n$hoverBg: darken($themeColor, 3%);\n$hoverColor: #fff;\n$hoverBorderColor: darken($themeColor, 10%);\n$subMenuHoverBg: $hoverBg;\n$subMenuHoverColor: $hoverColor;\n$menuBg: #fff;\n$blue: #012d55;\n\n// general\n$darkGrey: #666;\n$badgeColor: #fff;\n$badgeBgColor: $darkGrey;\n$greenColor: #28a745;\n$redColor: #dc3545;\n$skyColor: $themeColor;\n$yellowColor: #ffc107;\n$bodyBg: #f3f3f3;\n$lightGrey: #999;\n\n$dropdown-bg: #fff;\n$dropdown-border: darken($dropdown-bg, 30%);\n\n$danger: $redColor;\n$warning: $yellowColor;\n$success: $greenColor;\n\n// Sidebar\n$sidebarBackground: #fff;\n$sidebarzIndex: 8;\n$sidebarHeadBg: #f9f9f9;\n$sidebarRowBg: #fff;\n$sidebarRowHoverBg: #eee;\n$sidebarRowColor: $darkGrey;\n\n// Footer\n\n$footerBackground: $themeColor;\n\n// typography\n$baseFontSize: 12px;\n$baseIconFontSize: 17px;\n\n$baseFontFamily: 'Open Sans', sans-serif;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
